import { CircularProgress, MenuButton, TableColumn, TableRow } from 'react-md'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { LoanStatus } from '@viilu-web/shared/enums/loans'
import { loanTableHeaders } from './loanHeaders'
import { getLoanRowValue } from './utils'
import type { Loan } from '@viilu-web/shared/types/loans'

type LoansTableRowProps = {
	loan: Loan
	onDraftLoanClick: (loan: Loan) => void
	menuItems: JSX.Element[] | null
	processing: boolean
}

const LoansTableRow = (props: LoansTableRowProps) => {
	const { loan, onDraftLoanClick, menuItems, processing } = props
	const intl = useIntl()
	const dispatch = useDispatch()

	const menu = !menuItems ? null : (
		<MenuButton
			id={'menu-button'}
			icon
			menuItems={menuItems}
			centered
			anchor={{
				x: MenuButton.HorizontalAnchors['CENTER'],
				y: MenuButton.VerticalAnchors['CENTER'],
			}}
		>
			more_vert
		</MenuButton>
	)

	const onRowClick = () => {
		if (processing) return
		// If loan is a draft (e.g active = false), we should not open the loan view dialog,
		// instead open the form creation dialog with loan info
		if (loan.status === LoanStatus.ACTIVE) {
			dispatch(push(window.location.pathname + '?luuid=' + loan.uuid))
		} else {
			onDraftLoanClick(loan)
		}
	}

	const renderTableColumns = () => {
		return loanTableHeaders.map((header) => {
			const { key, type } = header
			return (
				<TableColumn
					key={key}
					onClick={onRowClick}
					style={{
						...(processing
							? { opacity: 0.5, cursor: 'not-allowed' }
							: { cursor: 'pointer' }),
					}}
				>
					{getLoanRowValue(loan, key, intl, type)}
				</TableColumn>
			)
		})
	}

	return (
		<TableRow key={loan.uuid}>
			{renderTableColumns()}
			<TableColumn key={'children'}>
				<div style={{ marginTop: '1rem' }}>
					{processing ? (
						<CircularProgress id="progress" style={{ marginTop: 0 }} />
					) : (
						menu
					)}
				</div>
			</TableColumn>
		</TableRow>
	)
}

export default LoansTableRow
